import { Updater } from "widgets-for-react"
import { CompanyState, initialCompanyState } from "../../forms/company/companyState"
import { initialPaymentMethodState, PaymentMethodState } from "../../forms/paymentMethod/paymentMethodState"
import { PausedSubscription, UserData } from "../subscriptionState"


export type ResumeSubscriptionState = Partial<{
  invoiceToCompany:boolean 
}> & {
  subscriptionToResume:PausedSubscription
  companyState:CompanyState
  paymentMethodState:PaymentMethodState
  isValid():boolean
}

export const initialResumeSubscriptionState = (subscriptionToResume:PausedSubscription, userData?:UserData) : ResumeSubscriptionState => ({
  subscriptionToResume:subscriptionToResume,
  companyState:initialCompanyState(userData),
  paymentMethodState:initialPaymentMethodState,
  isValid:function(this:ResumeSubscriptionState) { 
    return (this.invoiceToCompany == false || this.companyState.isValid()) && this.paymentMethodState.isValid() }
})

export const changePaymentMethodUpdaters = {
  invoiceToCompany:(u:Updater<ResumeSubscriptionState["invoiceToCompany"]>) : Updater<ResumeSubscriptionState> =>
    s => ({...s, invoiceToCompany:u(s.invoiceToCompany)}),
  companyState:(u:Updater<ResumeSubscriptionState["companyState"]>) : Updater<ResumeSubscriptionState> =>
    s => ({...s, companyState:u(s.companyState)}),
  paymentMethodState:(u:Updater<ResumeSubscriptionState["paymentMethodState"]>) : Updater<ResumeSubscriptionState> =>
    s => ({...s, paymentMethodState:u(s.paymentMethodState)}),
}

export const resumeSubscriptionInputUpdaters = {
  invoiceToCompany:(u:Updater<ResumeSubscriptionState["invoiceToCompany"]>) : Updater<ResumeSubscriptionState> =>
    s => ({...s, invoiceToCompany:u(s.invoiceToCompany)}),
  companyState:(u:Updater<ResumeSubscriptionState["companyState"]>) : Updater<ResumeSubscriptionState> =>
    s => ({...s, companyState:u(s.companyState)}),
  paymentMethodState:(u:Updater<ResumeSubscriptionState["paymentMethodState"]>) : Updater<ResumeSubscriptionState> =>
    s => ({...s, paymentMethodState:u(s.paymentMethodState)})
}
